import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { MusicPlayerProvider } from "@/contexts/MusicPlayerContext";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import LandingPage from "@/pages/LandingPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import PublicProfilePage from "@/pages/PublicProfilePage";
import TosGate from "@/components/TosGate";
import "@/App.css";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen flex items-center justify-center bg-[#0b0e14] text-slate-500 font-mono text-sm">Authenticating…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return <>{children}<TosGate /></>;
}

function RedirectIfAuthed({ children }) {
  const { user } = useAuth();
  if (user && typeof user === "object") return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <MusicPlayerProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<RedirectIfAuthed><AuthPage mode="login" /></RedirectIfAuthed>} />
            <Route path="/register" element={<RedirectIfAuthed><AuthPage mode="register" /></RedirectIfAuthed>} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/account" element={<Protected><AccountPage /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
            <Route path="/u/:userId" element={<Protected><PublicProfilePage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </MusicPlayerProvider>
    </AuthProvider>
  );
}
